import { render, staticRenderFns } from "./GConfirmationModal.vue?vue&type=template&id=db9ec784&scoped=true&"
import script from "./GConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./GConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./GConfirmationModal.vue?vue&type=style&index=0&id=db9ec784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9ec784",
  null
  
)

export default component.exports